import { OptionsCodes, OptionsAction } from './types';

export const ACTION = {
  REQUEST_CODETABLE: 'OPTIONS:REQUEST_CODETABLE',
  RECEIVE_CODETABLE: 'OPTIONS:RECEIVE_CODETABLE',
  FAIL_CODETABLE: 'OPTIONS:FAIL_CODETABLE'
};

export class RequestCodetable implements OptionsAction {
  public type: string = ACTION.REQUEST_CODETABLE;
  constructor(public path: string, public id: string, public query: string) {
  }
}

export class ReceiveCodetable implements OptionsAction {
  public type: string = ACTION.RECEIVE_CODETABLE;

  constructor(public path: string, public id: string, public query: string, public values: OptionsCodes) {
  }
}

export class FailCodetable implements OptionsAction {
  public type: string = ACTION.FAIL_CODETABLE;

  constructor(public path: string, public id: string, public query: string) {
  }
}
